/**
 * @generated SignedSource<<9ee77f54bb9332f4676335e626d51f90>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ContentContainerTheme_space$data = {
  readonly lookAndFeel: {
    readonly content: {
      readonly container: {
        readonly background: string | null;
        readonly backgroundAttachment: string | null;
        readonly backgroundBlendMode: string | null;
        readonly backgroundClip: string | null;
        readonly backgroundColor: string | null;
        readonly backgroundImage: string | null;
        readonly backgroundOrigin: string | null;
        readonly backgroundPosition: string | null;
        readonly backgroundRepeat: string | null;
        readonly backgroundSize: string | null;
        readonly borderRadius: string | null;
        readonly padding: string | null;
      } | null;
      readonly screen: {
        readonly background: string | null;
        readonly backgroundAttachment: string | null;
        readonly backgroundBlendMode: string | null;
        readonly backgroundClip: string | null;
        readonly backgroundColor: string | null;
        readonly backgroundImage: string | null;
        readonly backgroundOrigin: string | null;
        readonly backgroundPosition: string | null;
        readonly backgroundRepeat: string | null;
        readonly backgroundSize: string | null;
        readonly gutterBottom: string | null;
        readonly gutterLeft: string | null;
        readonly gutterRight: string | null;
        readonly gutterTop: string | null;
        readonly layer: {
          readonly background: string | null;
          readonly backgroundAttachment: string | null;
          readonly backgroundBlendMode: string | null;
          readonly backgroundClip: string | null;
          readonly backgroundColor: string | null;
          readonly backgroundImage: string | null;
          readonly backgroundOrigin: string | null;
          readonly backgroundPosition: string | null;
          readonly backgroundRepeat: string | null;
          readonly backgroundSize: string | null;
          readonly height: string | null;
          readonly width: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
  readonly theme: {
    readonly name: string | null;
    readonly themeKey: string | null;
  } | null;
  readonly " $fragmentType": "ContentContainerTheme_space";
};
export type ContentContainerTheme_space$key = {
  readonly " $data"?: ContentContainerTheme_space$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentContainerTheme_space">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "background"
},
v1 = {
  "kind": "ScalarField",
  "name": "backgroundColor"
},
v2 = {
  "kind": "ScalarField",
  "name": "backgroundImage"
},
v3 = {
  "kind": "ScalarField",
  "name": "backgroundPosition"
},
v4 = {
  "kind": "ScalarField",
  "name": "backgroundSize"
},
v5 = {
  "kind": "ScalarField",
  "name": "backgroundRepeat"
},
v6 = {
  "kind": "ScalarField",
  "name": "backgroundOrigin"
},
v7 = {
  "kind": "ScalarField",
  "name": "backgroundClip"
},
v8 = {
  "kind": "ScalarField",
  "name": "backgroundAttachment"
},
v9 = {
  "kind": "ScalarField",
  "name": "backgroundBlendMode"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ContentContainerTheme_space",
  "selections": [
    {
      "concreteType": "Theme",
      "kind": "LinkedField",
      "name": "theme",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "ScalarField",
          "name": "themeKey"
        }
      ]
    },
    {
      "concreteType": "LookAndFeel",
      "kind": "LinkedField",
      "name": "lookAndFeel",
      "plural": false,
      "selections": [
        {
          "concreteType": "ContentLookAndFeel",
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            {
              "concreteType": "ScreenLookAndFeel",
              "kind": "LinkedField",
              "name": "screen",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                (v2/*: any*/),
                (v3/*: any*/),
                (v4/*: any*/),
                (v5/*: any*/),
                (v6/*: any*/),
                (v7/*: any*/),
                (v8/*: any*/),
                (v9/*: any*/),
                {
                  "concreteType": "LayerScreenLookAndFeel",
                  "kind": "LinkedField",
                  "name": "layer",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v1/*: any*/),
                    (v2/*: any*/),
                    (v3/*: any*/),
                    (v4/*: any*/),
                    (v5/*: any*/),
                    (v6/*: any*/),
                    (v7/*: any*/),
                    (v8/*: any*/),
                    (v9/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "width"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "height"
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "gutterTop"
                },
                {
                  "kind": "ScalarField",
                  "name": "gutterRight"
                },
                {
                  "kind": "ScalarField",
                  "name": "gutterBottom"
                },
                {
                  "kind": "ScalarField",
                  "name": "gutterLeft"
                }
              ]
            },
            {
              "concreteType": "ContainerLookAndFeel",
              "kind": "LinkedField",
              "name": "container",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                (v2/*: any*/),
                (v3/*: any*/),
                (v4/*: any*/),
                (v5/*: any*/),
                (v6/*: any*/),
                (v7/*: any*/),
                (v8/*: any*/),
                (v9/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "padding"
                },
                {
                  "kind": "ScalarField",
                  "name": "borderRadius"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Space"
};
})();

(node as any).hash = "bfa43eb9ba39936a810f3d392573282f";

export default node;
